import { ThinkingOrb } from 'thinking-orbs'
import { cn } from '@/lib/utils'

/**
 * ResiDesk wrapper for indeterminate loading indicators.
 *
 * Thinking Orbs ships tuned 20px and 64px canvases. Smaller inline sizes use
 * the 20px drawing and scale its display box so controls keep their existing
 * dimensions.
 */
export function LoadingOrb({
  state = 'working',
  size = 20,
  label,
  className,
  style,
  ...props
}) {
  const presetSize = size > 20 ? 64 : 20

  return (
    <ThinkingOrb
      state={state}
      size={presetSize}
      theme="auto"
      aria-label={label}
      className={cn('shrink-0', className)}
      style={{ width: size, height: size, ...style }}
      {...props}
    />
  )
}

export default LoadingOrb
